var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1302_96632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0523 17.1717L21.0936 0.236997C20.7406 -0.0789992 20.2739 -0.0789992 19.9148 0.236997L0.94994 17.1717C0.477189 17.5957 0.357495 18.4331 0.684145 19.0466C1.01079 19.6601 1.65602 19.8155 2.12874 19.3916L4.91857 16.9031V38.6517C4.91857 39.3944 5.38523 40 5.9574 40H15.8263C16.3985 40 16.8651 39.3943 16.8651 38.6517V26.5175H24.1369V38.6517C24.1369 39.3944 24.6036 40 25.1757 40H34.5252C35.0974 40 35.564 39.3943 35.564 38.6517V16.44L38.8733 19.3919C39.0559 19.5525 39.2568 19.6289 39.4596 19.6289C39.7924 19.6289 40.115 19.4261 40.3159 19.0417C40.6425 18.4281 40.5228 17.5854 40.0501 17.1668L40.0523 17.1717Z",
    fill: "#219EBC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1302_96632",
    x: -3.5,
    y: -4,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1302_96632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1302_96632",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelHome);
export default __webpack_public_path__ + "static/media/selHome.ae5da380eea4ccfa9cbb8bfc03a86b44.svg";
export { ForwardRef as ReactComponent };